<template>
  <div class="sign-info">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="580px"
      :before-close="handleClose"
    >
      <el-form v-loading="loading" ref="signInfoEl" :model="signInfoForm" :rules="rules" label-width="110px">
        <el-form-item label="协议公司名称" prop="contractCompanyName">
          <el-input v-model="signInfoForm.contractCompanyName" maxlength="50" placeholder="请填写协议公司名称" />
        </el-form-item>
        <el-form-item label="协议公司地址" prop="contractCompanyAddress">
          <el-input v-model="signInfoForm.contractCompanyAddress" maxlength="200" placeholder="请填写协议公司名称" />
        </el-form-item>
        <el-form-item label="印章图片" prop="contractCompanySeal">
          <Upload v-model="signInfoForm.contractCompanySeal" @input="$refs.signInfoEl.clearValidate('contractCompanySeal')">
            <img
              class="seal-img"
              slot="img"
              v-if="signInfoForm.contractCompanySeal"
              :src="signInfoForm.contractCompanySeal"
              alt="印章图片"
            />
          </Upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanySignInfo, updataeSignInfo } from '@/api/organization';
import Upload from "@/components/upload.vue";

export default {
  name: 'SignInfo',

  components: { Upload },
  data () {
    return {
      dialogTitle: "",
      dialogVisible: false,
      loading: false,
      signInfoForm: {
        contractCompanyName: '',
        contractCompanyAddress: '',
        contractCompanySeal: ''
      },
      rules: {
        contractCompanyName: [
          { required: true, message: "请输入协议公司名称", trigger: "blur" },
        ],
        contractCompanyAddress: [
          { required: true, message: "请输入协议公司地址", trigger: "blur" },
        ],
        contractCompanySeal: [
          { required: true, message: "请上传印章图片", trigger: "change" },
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.loading = true
      this.signInfoForm.id = id
      getCompanySignInfo({ id }).then(({ code, data }) => {
        if (code === 0) {
          this.signInfoForm.contractCompanyName = data.contractCompanyName || ''
          this.signInfoForm.contractCompanyAddress = data.contractCompanyAddress || ''
          this.signInfoForm.contractCompanySeal = data.contractCompanySeal || ''
        }
      }).finally(() => {
        this.loading = false
      })
      this.dialogVisible = true
    },
    handleSubmit () {
      this.$refs.signInfoEl.validate(valid => {
        if (valid) {
          updataeSignInfo(this.signInfoForm).then(({ code }) => {
            if (code === 0) {
              this.$message.success('保存成功!')
              this.handleClose()
            }
          })
        }
      })
    },
    handleClose () {
      this.$refs.signInfoEl && this.$refs.signInfoEl.resetFields()
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-info {
  ::v-deep .el-upload-dragger {
    width: 240px;
    height: 240px;
  }
  .seal-img {
    width: 100%;
    height: 100%;
  }
}
</style>
